/**
 * Section constants for Physical Activity v2. Activities themselves are
 * fetched from api-activity-v2-service — this file just holds the status +
 * intensity band lookups used by the table chips and the two modals.
 */

/**
 * Status bands (Active / Occasional / Inactive). `key` matches the backend
 * enum on api-activity-v2-service.
 */
/* Hexes read off board 3071:4149. `inactive` is NOT drawn there — the mock
   only carries Active and Occasional — so it keeps its previous values. */
export const ACTIVITY_STATUS = [
  { key: "active", label: "Active", bg: "#d1fae5", fg: "#065f46", dot: "#065f46" },
  { key: "occasional", label: "Occasional", bg: "#fff5eb", fg: "#eb732e", dot: "#eb732e" },
  { key: "inactive", label: "Inactive", bg: "#f4f5f7", fg: "#4a5565", dot: "#8a94a6" },
];

export const activityStatusBand = (key) =>
  ACTIVITY_STATUS.find((s) => s.key === key) || ACTIVITY_STATUS[0];

/**
 * Intensity bands (Light / Moderate / Vigorous).
 */
/* All three drawn on 3071:4149 (Light 3071:4208, Moderate 3071:4220,
   Vigorous 3071:4232). The dot carries the label's own ink on every one.

   Moderate was #fef3c7/#92400e off 3071:4149, but the trend board 4056:3287
   inks the SAME chip #ffedd5/#f97316. The two boards disagreed; the orange is
   the one adopted, so it is set here — the single source both the section
   table and the trend modal read — rather than forked per surface, which
   would show one activity in two colours. */
export const ACTIVITY_INTENSITY = [
  { key: "light", label: "Light", bg: "#d1fae5", fg: "#065f46", dot: "#065f46" },
  { key: "moderate", label: "Moderate", bg: "#ffedd5", fg: "#f97316", dot: "#f97316" },
  { key: "vigorous", label: "Vigorous", bg: "#fee2e2", fg: "#9b1c1c", dot: "#9b1c1c" },
];

export const activityIntensityBand = (key) =>
  ACTIVITY_INTENSITY.find((i) => i.key === key) || ACTIVITY_INTENSITY[0];

// Description word cap — same 250-word ceiling used across other v2 sections.
// Shared between ActivityForm (Add/Edit) and ActivityStatusForm.
export const MAX_DESCRIPTION_WORDS = 250;
export const countWords = (s) => {
  const t = (s || "").trim();
  return t ? t.split(/\s+/).length : 0;
};
export const clampWords = (next, max) => {
  if (countWords(next) <= max) return next;
  const parts = next.split(/(\s+)/);
  let words = 0;
  const out = [];
  for (const chunk of parts) {
    if (/^\s+$/.test(chunk)) { out.push(chunk); continue; }
    if (chunk === "") continue;
    if (words >= max) break;
    out.push(chunk);
    words += 1;
  }
  return out.join("").replace(/\s+$/, "");
};
